module.exports = __webpack_public_path__ + "static/media/ios-hourglass.3f0df339.svg";